var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermanentMeds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2226 5.63965H21.5274C22.1999 5.63965 22.75 6.19188 22.75 6.86687V11.1623C22.75 11.8374 22.1999 12.3896 21.5274 12.3896H11.2226C10.5502 12.3896 10 11.8374 10 11.1623V6.86687C10 6.19188 10.5502 5.63965 11.2226 5.63965Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 13.1396V13.7604C21.25 16.073 25 16.1794 25 18.1586V21.0004",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2224 33.3896H9.52716C8.55169 33.3896 7.75 32.572 7.75 31.5723V18.4971C7.75 16.3794 11.1597 16.2724 11.1597 13.8021V13.1396",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 19.8896H15.4722V28.1396H7.75V19.8896Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2586 18.3457C21.0544 18.0168 21.9299 18.3729 22.2687 19.1085L23.9965 22.8603C24.1537 22.4938 24.4568 22.1802 24.8646 22.0115L24.865 22.0115C25.5901 21.7119 26.405 21.9702 26.7785 22.5848C26.9001 22.1335 27.2353 21.7333 27.7163 21.5343H27.7168C28.4417 21.2351 29.2566 21.4933 29.6302 22.1077C29.7518 21.6564 30.087 21.2561 30.5683 21.0573C31.3641 20.7287 32.3112 21.0558 32.5783 21.8203L34.5433 27.4456C36.1408 32.0196 30.4377 36.8429 26.1651 34.078L18.7538 29.2827C18.0605 28.8343 17.9014 27.9083 18.4 27.2248C19.189 26.8991 20.7497 26.9166 21.4478 27.3684L22.8513 28.2766L19.3756 20.3037C19.0521 19.5613 19.463 18.6745 20.2586 18.3457Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentMeds);
export default __webpack_public_path__ + "static/media/PermanentMeds.d571ed97c4f9f2d57d7f28bc09deeb04.svg";
export { ForwardRef as ReactComponent };